
import { computed, defineComponent, onMounted, reactive, toRefs, watch } from 'vue'

export default defineComponent({
    name: 'headPortrait',
    components: {
    },
    emits: ['changePage'],
    props: {
        pageSizeCompone: {
            type: Number,
            default: 12
        },
        totalCompone: {
            type: Number,
            default: 0
        },
        paddingActive: {
            type: Boolean,
            default: false
        }
    },
    setup(props: any, { emit }: any) {
        const state = reactive({
            handleSizeChange(val: number) {
                console.log(`${val} items per page`)
            },
            handleCurrentChange(val: number) {
                console.log(`current page: ${val}`)
                emit('changePage',val)
            },
        })

        onMounted(() => {

        })

        return {
            ...toRefs(state),
        }
    }
})

